<template>
  <div class="skin-list">
    <div class="scroll-wrapper" ref="scroll">
      <div class="scroll-content">
        <template v-for="key in Object.keys(dataSource)">
          <a
            class="item"
            :key="key"
            :href="dataSource[key].link.value"
            target="_blank"
            v-if="
              dataSource[key].cover.hasValue &&
                dataSource[key].title.hasValue &&
                dataSource[key].cover.value &&
                dataSource[key].title.value
            "
          >
            <div class="icon">
              <img class="poster" :src="dataSource[key].cover.value" />
              <img class="border" src="@/assets/nikke_imgs/gonglue.png" />
            </div>
            <div class="name">
              {{ dataSource[key].title.value }}
            </div>
          </a>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import BScroll from "@better-scroll/core";
export default {
  name: "SkinEvalution",
  props: {
    dataSource: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {};
  },
  computed: {},
  mounted() {
    this.initBS();
  },
  methods: {
    initBS() {
      this.bs = new BScroll(this.$refs.scroll, {
        scrollX: true,
        probeType: 3
      });
    }
  }
};
</script>

<style lang="less" scoped>
.skin-list {
  width: 100%;
  .scroll-wrapper {
    white-space: nowrap;
    width: 100%;
    overflow: hidden;
    padding: 0 16px 10px;
    .scroll-content {
      display: inline-block;
    }
  }
  .item {
    position: relative;
    width: 119px;
    display: inline-block;
    margin-right: 12px;
    .icon {
      position: relative;
      width: 122px;
      height: 66px;
      margin-bottom: 6px;
      border-radius: 8px;
      .poster {
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: center;
      }
      .border {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        z-index: 1;
      }
    }
    .name {
      width: 100%;
      font-weight: 400;
      font-size: 13px;
      color: #142630;
      text-align: center;
      line-height: 20px;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
  }
}
</style>
